import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategoryDropdown from "./components/CategoryDropdown";
import CategoryGrid from "./components/CategoryGrid";
import ArticleSection from "./components/ArticleSection";
import FaqSection from "./components/FaqSection";
import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function Home() {
  const { t } = useTranslation();

  const siteUrl = import.meta.env.VITE_SITE_URL || "https://usfanslink.pics";
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        url: siteUrl,
        name: "USFansLink",
        description:
          "USFansLink is an independent resource hub organizing USFans spreadsheet links, creator lists, reviews, shipping guides, coupons and comparisons.",
        inLanguage: "en",
      },
      {
        "@type": "Organization",
        "@id": `${siteUrl}/#organization`,
        name: "USFansLink",
        url: siteUrl,
        logo: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg",
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />

        <section id="categories" className="mx-auto max-w-7xl px-4 md:px-6 py-16">
          <div className="text-center mb-8">
            <h2 className="font-heading font-semibold text-2xl md:text-4xl text-foreground-950">{t("categories.title")}</h2>
            <p className="mt-3 text-foreground-600 max-w-2xl mx-auto">{t("categories.subtitle")}</p>
          </div>

          <div className="mb-10">
            <CategoryDropdown />
          </div>

          <CategoryGrid />
        </section>

        <ArticleSection />

        <FaqSection />

        <section className="mx-auto max-w-7xl px-4 md:px-6 py-16">
          <div className="rounded-2xl bg-primary-500 text-background-50 text-center px-6 py-14">
            <h2 className="font-heading font-semibold text-2xl md:text-4xl">{t("cta.title")}</h2>
            <p className="mt-3 text-background-50/90 max-w-xl mx-auto">{t("cta.subtitle")}</p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-background-50 text-primary-700 font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-links-line text-lg" />
                {t("hero.ctaPrimary")}
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-600 text-background-50 font-semibold hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-bag-3-line text-lg" />
                {t("hero.ctaSecondary")}
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    </div>
  );
}